module.exports = __webpack_public_path__ + "media/icons/calendar-feb3fcca.svg";